module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/142-tibet-0336a9c1239344dbc06e41be069d1538.svg";